import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { FaRegHandshake } from 'react-icons/fa';
import { FiCalendar } from 'react-icons/fi';
import {
  diaDaSemana,
  diaSeguinte,
  formatarData,
} from '~/config/encerramentoSistema';
import CartaoContato from './CartaoContato';
import {
  BotaoFecharModal,
  BotaoPrimario,
  CabecalhoModal,
  CorpoModal,
  DestaquePrazo,
  EstiloGlobalModal,
  IconeCabecalho,
  RodapeModal,
} from './styles';

interface ModalComunicadoProps {
  show: boolean;
  onClose(): void;
  ultimoDiaDeAcesso: string;
  diasAteUltimoDia: number;
}

const ModalComunicado: React.FC<ModalComunicadoProps> = ({
  show,
  onClose,
  ultimoDiaDeAcesso,
  diasAteUltimoDia,
}) => {
  const ultimoDia = `${diaDaSemana(ultimoDiaDeAcesso)}, ${formatarData(
    ultimoDiaDeAcesso,
  )}`;

  let tituloPrazo = `Faltam ${diasAteUltimoDia} dias`;
  let detalhePrazo = `para o último dia de acesso (${formatarData(
    ultimoDiaDeAcesso,
  )})`;

  if (diasAteUltimoDia <= 1) {
    tituloPrazo =
      diasAteUltimoDia === 0
        ? 'Hoje é o último dia de acesso'
        : 'Amanhã é o último dia de acesso';
    detalhePrazo = ultimoDia;
  }

  return (
    <>
      <EstiloGlobalModal />
      <Modal
        show={show}
        onHide={onClose}
        centered
        className="modal-comunicado-encerramento"
        backdropClassName="modal-comunicado-encerramento-fundo"
        dialogClassName="modal-comunicado-encerramento-dialogo"
        contentClassName="modal-comunicado-encerramento-conteudo"
        aria-labelledby="titulo-comunicado-encerramento"
      >
        <CabecalhoModal>
          <BotaoFecharModal
            type="button"
            onClick={onClose}
            aria-label="Fechar comunicado"
          >
            <AiOutlineClose size={18} />
          </BotaoFecharModal>
          <IconeCabecalho>
            <FaRegHandshake size={30} aria-hidden />
          </IconeCabecalho>
          <h2 id="titulo-comunicado-encerramento">Comunicado importante</h2>
          <span>Uma mensagem especial para você, nosso cliente</span>
        </CabecalhoModal>

        <CorpoModal>
          <p>Prezado(a) cliente,</p>
          <p>
            Agradecemos sinceramente pela confiança e pela parceria ao longo de
            toda essa jornada.
          </p>
          <p>
            Informamos que o acesso a este sistema será encerrado. O último dia
            de utilização será <strong>{ultimoDia}</strong> e, a partir de{' '}
            <strong>{formatarData(diaSeguinte(ultimoDiaDeAcesso))}</strong>, o
            acesso não estará mais disponível.
          </p>

          <DestaquePrazo urgente={diasAteUltimoDia <= 2}>
            <FiCalendar size={24} aria-hidden />
            <div>
              <strong>{tituloPrazo}</strong>
              <span>{detalhePrazo}</span>
            </div>
          </DestaquePrazo>

          <CartaoContato />
        </CorpoModal>

        <RodapeModal>
          <BotaoPrimario type="button" onClick={onClose}>
            Entendi
          </BotaoPrimario>
        </RodapeModal>
      </Modal>
    </>
  );
};

export default ModalComunicado;
